<template>
  <div v-show="value" ref="dialog" class="submit_dialog">
    <img src="//vipcdn.mgtv.com/upload/20180408/close.png" class="close" @click="handleAction('cancel')"/>

    <div class="content">
      <div class="title" v-html="this.submitDialog.title"></div>
      <div class="fields">
        <div
          class='field'
          v-for="item,index in this.fields"
          :key="index"
        >
          <div class="label" v-if="item.label">{{item.label}}</div>
          <textarea
            v-if="item.input_type === 'textarea'"
            rows="3"
            :placeholder="item.placeholder"
            v-model="field_values[index]"
            :disabled="recv_info"
          ></textarea>

          <select class="select" v-else-if="item.input_type === 'select'"
            v-model="field_values[index]"
          >
            <option v-for="(op,index) in item.options" v-if="op"  :value="op===UNSELECT_VALUE?'':op" :key="index">{{op}}</option>

          </select>

          <div v-else-if="item.input_type === 'img'" class="uploader">

            <MiniUploader v-model="field_values[index]"></MiniUploader>

          </div>

          <input
            v-else
            :type="item.input_type"
            :placeholder="item.placeholder"
            v-model="field_values[index]"
            :disabled="recv_info"
          />

        </div>
      </div>
      <div class="submit" @click.prevent="submit()">
        {{this.submitDialog.submit}}
      </div>
    </div>


  </div>
</template>
<script>
  import create from 'vant/lib/utils/create';
  import Popup from 'vant/lib/mixins/popup';
  import {setStyle} from '../../../tools/dom'
  import {is_idcard, is_mobile} from '../../../tools/validate'
  import Cookie from '../../../tools/cookie';
  import {click_event} from '../../../tools/mgtv/analysis'
  import {Picker} from 'vant';
  import {isArray} from '../../../tools/typeof'
  import MiniUploader from './MiniUploader';

  const SAVE_USER_SUBMIT_KEY = '_act_save_submit_2019';

  //自定义input类型
  const INPUT_TYPES = {
    NAME: 'name',
    TEL: 'tel', //具有特殊匹配规则
    ADDRESS: 'address',
    IDCARD: 'idcard',//具有特殊匹配规则
  }

  const UNSELECT_VALUE = '请选择'
  export default create({
    name: 'SubmitDialog',
    components: {MiniUploader},
    mixins: [Popup],
    props: {
      callback: Function,
      overlay: {
        type: Boolean,
        default: true
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false
      },
      lockOnScroll: {
        type: Boolean,
        default: true
      },
      submitDialog: {
        type: Object,
        default: function () {
          return {
            title: '提交中奖信息',
            submit: '确认',
            fields: []
          }
        }
      },
      submitAction: {
        type: Function,
        default: function (res) {
          console.log('submitAction', res)
          return new Promise((resolve, reject) => {
            resolve('success');
          })
        }
      },
      recv_info: { //2018-12-21新增-已提交的信息，此时弹窗是只读的
        type: Object,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        field_values: ['', '', '', '', '', '', '', '', '', '', '', '','','','',''],
        UNSELECT_VALUE: UNSELECT_VALUE
      }
    },
    methods: {

      handleAction(action) {
        this.$emit('input', false);
        this.$emit(action);
        this.callback && this.callback(action);
      },
      calc_result() {
        if (this.fields) {
          const result = [];
          for (let i = 0; i < this.fields.length; ++i) {
            const item = this.fields[i];
            const value = this.field_values[i];
            if (!item.valid_func(value)) {
              return null;
            }
            result.push({
              label: item.label,
              type: item.type,
              value
            })
          }
          return result;
        } else {
          return null;
        }
      },
      save_result(result) {
        if (!this.fields) {
          return;
        }
        //将保存提交结果存放在本地
        if (!result) {
          return;
        }
        let save_result = Cookie.getJSON(this.user_save_key) || {};
        result.forEach(item => {
          save_result[item.label] = item.value;
        });
        Cookie.setJSON(this.user_save_key, save_result, {expires: 3}); //3
      },
      init_field_value() {
        //使用本地结果初始化input中的值
        let save_result = Cookie.getJSON(this.user_save_key) || {};
        if (this.recv_info) {
          save_result = this.recv_info;
        }
        this.field_values = ['', '', '', '', '', '', '', '', '', '', '', '','','','',''];
        if (this.fields) {
          this.fields.forEach((item, index) => {
            this.field_values[index] = save_result[item.label] || '';
          })
        }
        console.log('init_field_value', this.field_values);
      },
      submit() {
        //已提交的情况
        if (this.recv_info) {
          this.handleAction('confirm');
          return;
        }
        const result = this.calc_result();
        console.log('submitDialog', result);
        //存放result;
        if (result !== null) {
          this.save_result(result);
          this.submitAction(result).then((res) => {
            if (res === 'success') {
              this.handleAction('confirm'); //关闭弹窗
              click_event('提交弹窗-提交成功')
            } else {
              click_event('提交弹窗-提交失败')
            }
          }).catch(err => {
            click_event('提交弹窗-提交异常')
          });
        }
      }
    },
    mounted() {
    },
    watch: {
      value(val) {
        console.log('value change', val)
        if (val) { //显示
          this.init_field_value();
        }
      }
    },
    computed: {
      user_save_key() {
        return SAVE_USER_SUBMIT_KEY + '_' + window.$bus.user.uuid;
      },
      fields() {
        if (!this.submitDialog.fields) {
          return []
        }

        return this.submitDialog.fields.map((_item, index) => {

            const item = Object.assign({}, _item);

            //设置input显示的类型
            item.input_type = item.type;
            switch (item.type) {
              case INPUT_TYPES.NAME:
                item.input_type = 'text';
                break;
              case INPUT_TYPES.TEL:
                item.input_type = 'number';
                break;
              case INPUT_TYPES.ADDRESS:
                item.input_type = 'textarea';
                break;
              case INPUT_TYPES.IDCARD:
                item.input_type = 'text';
                break;
              default:
                item.input_type = item.type;
            }

            if (item.options) {
              item.options = item.options.replace(/；/g, ';').split(';');
              if (isArray(item.options)) {
                item.options.unshift(UNSELECT_VALUE);
              }
            }


            item.valid_func = value => { //判断格式

              if (item.type === INPUT_TYPES.IDCARD) {
                if (!is_idcard(value)) {
                  window.$toast(`${item.label}格式不正确`);
                  return false;
                }
              } else if (item.type === INPUT_TYPES.TEL) {
                if (!is_mobile(value)) {
                  window.$toast(`${item.label}格式不正确`);
                  return false;
                }
              } else if (item.input_type === 'text' || item.input_type === 'textarea') {
                if (item.max && value.length > item.max) {
                  window.$toast(`${item.label}最多只能填写${item.max}个字`);
                  return false
                }
                if (item.min && value.length < item.min) {
                  window.$toast(`${item.label}最少需要填写${item.min}个字`);
                  return false;
                }
                if (value.includes('>') || value.includes('<')) {
                  window.$toast(`${item.label}请勿提交特殊字符`);
                  return false;
                }
              } else{
                if(!value){
                  window.$toast(`${item.label}不可为空`);
                  return false;
                }
              }
              return true
            };
            return item
          }
        )
      }
    }
  });
</script>


<style lang="stylus" scoped>
  @import "../../../share/mixins.styl"

  .submit_dialog
    padding 1.1rem .3rem .5rem .3rem
    background white
    center()
    border-radius 0.2rem
    color #717171
    position fixed !important

  .close
    position absolute
    top -.2rem
    right 0
    width .73rem
    height .84rem
    z-index 2
    box-sizing content-box
    padding .2rem

  .title
    text-align center
    font-size .32rem

  .content
    overflow hidden
    position relative
    width 6rem
    .fields
      margin-top .2rem
      padding .1rem 0
      .field
        padding .1rem 0
      .label
        text-align left
        width 1.5rem
        height .6rem
        line-height .6rem
        font-size .3rem
        margin-left .2rem
        display inline-block
        vertical-align top
        margin-right .2rem

      input
        display inline-block
        outline none
        height .6rem
        line-height .6rem
        width 3.6rem
        border none
        background #e8e8e8
        border-radius .1rem
        padding 0 .1rem
        font-size .3rem
        color #717171
        &::placeholder
          color #b8b8b8
      textarea
        width 3.6rem
        display inline-block
        outline none
        border none
        background #e8e8e8
        line-height .4rem
        border-radius .1rem
        padding .1rem .1rem
        resize none
        font-size .3rem
        color #717171
        &::placeholder
          color #afafaf
      .select
        display inline-block
        font-size .3rem
        background white
        border-radius .1rem
        height .6rem
        line-height .6rem
        border: 1px solid #aaa;
        width 3.6rem;
        option
          line-height .6rem
          height .6rem
      .uploader
        display inline-block
    /*.title*/
    /*width 100%*/
    /*text-align center*/
    /*font-size .4rem*/

    /*.sub_title*/
    /*width 100%*/
    /*text-align center*/
    /*font-size .3rem*/
    /*margin-top .2rem*/

    .submit
      background url(//vipcdn.mgtv.com/upload/20180408/btn.png) no-repeat
      background-size cover
      width 3.96rem
      height 1.05rem
      text-align center
      color white
      margin .7rem auto 0 auto
      font-size .36rem
      padding-top .22rem

  .inline-block
    display inline-block
</style>



// WEBPACK FOOTER //
// src/components/Popups/SubmitDialog/SubmitDialog.vue